import React from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

export interface MonthDayPickerProps {
  label?: string
  id?: string
  selected: Date | null
  onChange: (date: Date | null) => void
  placeholderText?: string
  disabled?: boolean
  minDate?: Date
  maxDate?: Date
  className?: string
  name?: string
  dateFormat?: string
  showYearDropdown?: boolean
  isClearable?: boolean
  required?: boolean
  hideHeaderYear?: boolean
}

const ReactDatePicker = ({
  label,
  id,
  selected,
  onChange,
  placeholderText = 'Select date',
  disabled = false,
  minDate,
  maxDate,
  className = '',
  dateFormat = 'MMM dd, yyyy',
  showYearDropdown = true,
  name,
  isClearable = false,
  required = false,
  hideHeaderYear = false
}: MonthDayPickerProps) => {
  const inputId = id || name || 'react-datepicker'

  return (
    <div className="datepicker-wrap">
      {label && (
        <label htmlFor={inputId} className="form-label">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <DatePicker
        id={inputId}
        selected={selected}
        onChange={(date) => onChange(date)}
        placeholderText={placeholderText}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        name={name}
        dateFormat={dateFormat}
        showYearDropdown={showYearDropdown}
        showMonthDropdown
        dropdownMode="select"
        className={`form-control ${className}`}
        isClearable={isClearable}
        showIcon={false}
        renderCustomHeader={
          hideHeaderYear
            ? ({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
              <div className="react-datepicker__header react-datepicker__header--custom">
                <button
                  type="button"
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                  className="react-datepicker__navigation react-datepicker__navigation--previous"
                  aria-label="Previous Month"
                >
                  <i className="fas fa-chevron-left" />
                </button>

                <span className="react-datepicker__current-month">
                  {date.toLocaleString('default', { month: 'long' })}
                </span>

                <button
                  type="button"
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                  className="react-datepicker__navigation react-datepicker__navigation--next"
                  aria-label="Next Month"
                >
                  <i className="fas fa-chevron-right" />
                </button>
              </div>
            )
            : undefined
        }
      />
    </div>
  )
}

export default ReactDatePicker
